/**
 * Feature-request form backed by an Asana form embed. The form lives in
 * Asana so submissions flow straight into the IT KPI Tracker project's
 * intake without any backend routing on our side. If Asana is down or
 * the iframe fails, the "Open in new tab" link is the fallback.
 */
import { useDocumentTitle } from '../hooks/useDocumentTitle'

export default function FeatureRequest() {
  useDocumentTitle('Request a Feature')
  return (
    <div className="max-w-4xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Request a Feature</h1>
        <p className="text-slate-500 text-sm mt-1">
          Got an idea or a pain point? Share it below. We'll triage it on the next review (weekly).
        </p>
      </div>

      {/* The form itself lives on form.asana.com so we can't restyle its
          internals (cross-origin). We can only control the wrapper. Keep
          the frame minimal so the form feels hosted, not dumped in. */}
      <div className="bg-slate-50/60 rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <iframe
          title="Feature request form"
          src="https://form.asana.com/?k=U3AbPXhwrAI-huFXvfB7Ag&d=11089874356922&embed=true"
          className="w-full block bg-white"
          style={{ height: '720px', border: 0 }}
        />
        <div className="px-5 py-3 border-t border-slate-200 text-[11px] text-slate-400 flex items-center justify-between bg-white">
          <span>Form powered by Asana</span>
          <a
            href="https://form.asana.com/?k=U3AbPXhwrAI-huFXvfB7Ag&d=11089874356922"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-500 font-medium hover:text-slate-700"
          >
            Open in new tab →
          </a>
        </div>
      </div>
    </div>
  )
}
